<div class="modal-header">
  <h4 class="modal-title">No Active Entry Method</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">

  <ng-container *ngIf="association">
    <div class="alert alert-danger">
      This customer could not be checked in because {{ association.name }} has no entry passes remaining. Please note that because the check-in is being performed from the Association Profile, any entry passes owned directly by the customer will not be used for check-in.
    </div>
  </ng-container>
  <ng-container *ngIf="!association">
    <p>
      <b>Purchase New Entry Method</b>
      <br>
      This customer does not have an active entry method. Please select "Go to Memberships & Passes" to purchase a new entry method or reactivate an old one.
    </p>

    <a routerLink="/customers/{{ customerId }}/memberships-and-passes"
       (click)="activeModal.dismiss()"
       class="btn btn-primary btn-block">
      Go to Memberships &amp; Passes
    </a>

    <p class="mt-3">
      <b>Provide Free Entry</b>
      <br>
      If this customer is entitled to a free entry, select "Provide Free Entry" and leave any notes necessary in the text field.
    </p>
  </ng-container>

  <div class="form-group">
    <label for="freeEntryReasonTextarea">Notes for Free Entry (optional)</label>
    <textarea class="form-control" id="freeEntryReasonTextarea" rows="4"
              [(ngModel)]="freeEntryReason"></textarea>
  </div>

  <button class="btn btn-primary btn-block"
          (click)="provideFreeEntryCallback(freeEntryReason);activeModal.dismiss()">
    Provide Free Entry
  </button>

  <button class="btn btn-block btn-secondary mt-4"
          (click)="activeModal.dismiss()">
    Back
  </button>

</div>
